import React from 'react';

const Title = ({ name }) => {
  return (
    <div className="task-card-title">
      {name.split(' ').length > 1 ? (
        <div>
          <h5 className="text-center">{name.split(' ')[0]}</h5>
          <h5 className="bold text-center">
            {name
              .split(' ')
              .map((val, i) => {
                if (i === 0) {
                  return '';
                }
                return val;
              })
              .join(' ')}
          </h5>
        </div>
      ) : (
        <h5 className="bold text-center">{name}</h5>
      )}
    </div>
  );
};

export default Title;
